// utils/taskStatus.ts

export const getTaskStatusLabel = (status?: string) => {
    switch (status) {
        case 'pending':
            return 'Locked';
        case 'todo':
            return 'Todo';
        case 'complete':
            return 'Complete';
        case 'cancelled':
            return 'Cancelled';
        case 'inReview':
            return 'InReview';
        case 'changesRequested':
            return 'ChangesRequested';
        default:
            return status || '';
    }
};